import React, { useState } from "react";
import IController from "@components/forms/IController";
import { useForm } from "react-hook-form";
import Form from "react-bootstrap/Form";
import { Rules } from "@dashboard/settings/rules/Rules";
import { getRoute } from "@services/axios";
import { useDispatch } from "react-redux";
import { updtaSettingWithValidation } from "../Action";
import { useTranslation } from "react-i18next";

const Personnal = (props) => {
  const { t } = useTranslation();
  const InputSection = props.InputSection;

  const rules = new Rules(t);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const {
    control,
    register,
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {
      email: props.profile.data.email,
      full_name: props.profile.data.full_name,
      phone: props.profile.data.phone,
      address: props.profile.data.address,
    },
  });

  const onSubmit = async (data) => {
    setLoading(true);

    const extraParam = {
      route: getRoute("profile_update"),
      t: t,
      title: t("enter_your_code_validation"),
      setLoading,
      dispatch,
      autorizateSetData: true,
    };

    await updtaSettingWithValidation(data, extraParam);
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit)}>
      {/* FULL NAME */}
      <InputSection
        title={t("full_name")}
        description={t("full_name_desc")}
        input={
          <IController
            elment="full_name"
            item={rules.fullName()}
            control={control}
            errors={errors}
            register={register}
          />
        }
      />

      <hr className="border-secondary my-4" />

      {/* EMAIL */}
      <InputSection
        title={t("email")}
        description={t("email_desc")}
        input={
          <IController
            elment="email"
            item={rules.email()}
            control={control}
            errors={errors}
            register={register}
          />
        }
      />

      <hr className="border-secondary my-4" />

      {/* PHONE */}
      <InputSection
        title={t("phone")}
        description={t("phone_desc")}
        input={
          <IController
            elment="phone"
            item={rules.phone()}
            control={control}
            errors={errors}
            register={register}
          />
        }
      />

      <hr className="border-secondary my-4" />

      {/* ADDRESS */}
      <InputSection
        title={t("address")}
        description={t("address_desc")}
        input={
          <IController
            elment="address"
            item={rules.address()}
            control={control}
            errors={errors}
            register={register}
          />
        }
      />

      <hr className="border-secondary my-4" />

      {/* SUBMIT */}
      <InputSection
        title=""
        description=""
        input={
          <Form
            as="button"
            type="submit"
            className="btn-blue p-4 rounded-3 fw-bold w-100"
          >
            {loading ? (
              <Form
                as="span"
                className="spinner-border spinner-border-sm m-1"
              />
            ) : (
              t("save")
            )}
          </Form>
        }
      />
    </Form>
  );
};

export default Personnal;